import moment from 'moment'
import { DatePicker, Button } from 'antd';
import { timePreferenceOptions } from '../../constant/global';

const SelectDateAndTime = ({ content, handleDateChange, disabledDateTime, selectedDate, selectTime, handleSelectTime }) => {
    return (
        <div style={{ marginTop: '5rem'}}>
            <div>
                <h5 className='text-title'>Selected Doctor</h5>
                {content}
            </div>

            <p className='form-text mb-3'>
                Tell us when suits you best — both fields are optional. Our team will coordinate
                with the specialist and confirm your actual appointment time after your request.
            </p>

            <dir className="row">

                <div className="col-md-5 col-sm-12 mt-3">
                    <h5 className='text-title mb-3'>Preferred Date (optional)</h5>
                    <DatePicker
                        format="YYYY-MM-DD"
                        disabledDate={disabledDateTime}
                        open={true}
                        onChange={handleDateChange}
                    />
                </div>

                <div className="col-md-7 col-sm-12 mt-3">
                    <h5 className='text-title mb-3'>
                        Preferred Time of Day (optional)
                        {selectedDate && <span className='form-text d-block mt-1'>Preferred date: {moment(selectedDate).format('LL')}</span>}
                    </h5>
                    <div className="date-card rounded p-4">
                        <div className="row text-center mt-3">
                            {timePreferenceOptions.map((option) => (
                                <div className="col-md-3 col-6" key={option.value}>
                                    <Button
                                        type={selectTime === option.value ? 'primary' : 'default'}
                                        shape="round"
                                        size="large"
                                        className="mb-3"
                                        onClick={() => handleSelectTime(option.value)}
                                    >
                                        {option.label}
                                    </Button>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </dir>
        </div>
    )
}

export default SelectDateAndTime;
